import { defineMessages } from "react-intl"

export const offerStatusMessages = defineMessages({
	COMPLETED: {
		defaultMessage: "Sold",
		id: "offer.status.completed",
	},
})
